import React from "react";
import {Link} from 'react-router-dom'
import './styles.scss'
import {CustomCard, LabelGroup} from "../index";

const Widget=({title,description,imgUri})=>{
  return(
    <CustomCard>
      <div className="row row-sm">
        <div className="col-6">
          <LabelGroup title={title} description={description}/>
          <p className="mb-0 tx-24 mt-2"><b className="text-primary">145 days</b></p>
          <Link to="/" className="text-muted tx-12">12 Monday, Oct 2020 </Link>
        </div>
        <div className="col-6">
          <img  src={imgUri} alt={title} className="best-emp"/>
        </div>
      </div>
    </CustomCard>
  )
}

export default Widget;
